import { applyPolyfills, defineCustomElements } from '@iress/components/loader';
export const defineIDS = ({ suffix }) => {
    applyPolyfills().then(() => {
        defineCustomElements(window, {
            transformTagName: (tagName) => `${tagName}${suffix}`,
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
        });
        // `as any` is needed for a known Stencil issue: https://github.com/ionic-team/stencil/issues/2847
    });
};
//# sourceMappingURL=define-ids.js.map